// src/utils/apiFetch.js
// Shared `fetch` helpers used by every API wrapper (quoteApi, valutApi, …).
//
// jsonOrThrow:
//   2xx with body         → parsed JSON
//   204                   → null
//   non-2xx               → throws Error with `.status` + `.body` populated;
//                           caller decides whether to surface, retry, or
//                           silently logout (e.g. 401 drift).
//
// authHeaders:
//   `null`/`undefined` token → empty headers (anonymous request)
//   token string             → `{ Authorization: "Bearer <token>" }`

export async function jsonOrThrow(res) {
    if (res.status === 204) return null;
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(body.message || `HTTP ${res.status}`);
        err.status = res.status;
        err.code = body.code || null;
        err.body = body;
        throw err;
    }
    return body;
}

export function authHeaders(token) {
    return token ? { Authorization: `Bearer ${token}` } : {};
}
